<template>
  <!-- 微信开放标签-打开微信小程序 -->
  <div style="height: 100%; position: relative">
    <wx-open-launch-weapp
      v-if="isWxConfigSuccess && (goodsItemData.vid || goodsItemData.cid || type)"
      id="launch-weapp"
      style="width: 100%; height: 100%; position: absolute; z-index: 10; left: 0; top: 0"
      username="gh_fce17bb0518f"
      :path="path"
      @error="handleErrorFn"
      @launch="handleLaunchFn"
    >
      <script type="text/wxtag-template">
        <div style="width:100%;height:100%;position: absolute;zIndex:10;left:0;top:0;opacity: 0;">打开小程序</div>
      </script>
    </wx-open-launch-weapp>
    <slot></slot>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
export default {
  props: ["goodsItem", "type", "reportUserConfig"],
  computed: {
    ...mapGetters(["isWxConfigSuccess"]),
    path() {
      const { cid, vid } = this.goodsItemData
      let path =
        this.type == "more" ? "/pages/index/index?channelId=100101" : `preload_play/play/index.html?vid=${vid || ""}&cid=${cid || ""}`
      return path
    },
    goodsItemData() {
      return this.goodsItem || {}
    }
  },
  methods: {
    ...mapActions(["reportUserAction"]),
    handleErrorFn(e) {
      console.log("fail", e.detail)
    },
    handleLaunchFn() {
      this.reportUserAction(this.reportUserConfig)
    }
  }
}
</script>
